import type { ExcDtcFilesV1FileKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../../util/routing/entity-paths';

export const DTC_FILE_BASE_PATH = getResolvedPath('/clearing/vendor/dtcc/file');

export const getDtcFilePath: EntityPathBuilder<ExcDtcFilesV1FileKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      return DTC_FILE_BASE_PATH;
    case 'detail': {
      if (!context?.keys?.fileId) {
        return undefined;
      }

      return getResolvedPath(`${DTC_FILE_BASE_PATH}/$fileId`, context.keys);
    }
  }
};

export function getDtcFileDetailPath(fileId: string | undefined) {
  if (!fileId) {
    return undefined;
  }

  return getDtcFilePath({ kind: 'detail', keys: { fileId } });
}
